import { render } from "./AppQuestions.vue?vue&type=template&id=039eac96&scoped=true"
import script from "./AppQuestions.vue?vue&type=script&lang=js"
export * from "./AppQuestions.vue?vue&type=script&lang=js"

import "./AppQuestions.vue?vue&type=style&index=0&id=039eac96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-039eac96"]])

export default __exports__